import { instagramMock, texteSeoMock, titreFiltresModelesMock } from '@mock/schema/components';
import { pushContenusMock } from '@mock/schema/components/push-contenus.mock';
import { pageBase } from '@mock/schema/slugs/config';
import { SlugPage } from '@pages/slug-page/models';

const blocks = [
  instagramMock,
  titreFiltresModelesMock(false),
  pushContenusMock('realisations-client'),
  texteSeoMock('gray'),
];

export const modeleListingMock: SlugPage = {
  ...pageBase({
    title: 'Listing cuisine',
    type: 'modele-listing',
    language: 'fr-FR',
    headerId: 'header-fr',
    footerId: 'footer-fr',
    isBreadcrumbOverlay: false,
  }),
  blocks,
};
